import { defineStore } from 'pinia'


export const QuarterStatus = defineStore('zn_q_stat', {
    state: () => {
        return {
            zn_q_stat: true
        }
    },
    actions: {
        get() {
            return this.zn_q_stat
        },
        set(data) {
            this.zn_q_stat = data
        }
    },
})
